export const Data = {
   Skills : [
    {h1: 'Responsive Web Design',
    p: 'mobile devices are by far the most used devices to access the internet today. Responsive web design is important to ensure seamless and top notch user experience on mobile and desktop devices while being consistent and keeping the user attention. I am highly skilled in making web pages mobile compliant and very responsive across most devices and browsers which ultimaely translate to higher traffic for your page.',
    id: 1,
    },

    {h1: 'Javascript ES6',
    p: 'HTML/CSS might be the building block and foundation of the web but javascript is the breath of life that makes for a robust internet experience. with high level skills in javascript library like React and Next.js, APIs and lots more, i can bring any static website to life with rich and dynamic UI that exponentially increases the user experience',
    id: 2,
    },

    {h1: 'Back-end Basics',
    p: 'With experience in python and python backend packages like django and flask, i can create simple but highly effective and scalable backend for web apps that run on the server',
    id: 3,
    },

    {h1: 'Search Engine Optimization',
    p: 'As web traffic becomes more important and crucial to the development of companies and startups, SEO has also become a much needed aspect of web pages. With my skills in SEO, i can make webpages that brings traffic that your business needs to get to the next level and beyond',
    id: 4,
    },

    {h1: 'Version Control',
    p: 'With hands on experience with version control tools like git and github, i can easily keep track and manage changes to your software codebase, track bugs and also work with much larger teams seamlessly to offer you the best result possible at blazingly fast speed',
    id: 5,
    },

    {h1: 'Analytics',
    p: 'Writing high quality and functional code that can be easily managed and read by others. I can analyse various wed data and optimize software for better effectiveness to further improve user experience!',
    id: 6,
    }
   ],
}